import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Card, Col, Row } from "react-bootstrap";
import { TrendingUp } from "react-feather";
import TableComponent from "../../../components/widgets/table/index";
import DownloadReport from "../../../components/widgets/modals/DownloadReport";
import { api_srv } from "services";
import { useQuery } from "react-query";
import { fetchIntermediaryCommisions } from "services/apiSrv";
import { getIn } from "formik";
import ViewIntermeediaryCommissionDetails from "components/widgets/modals/ViewIntermeediaryCommissionDetails";

function AccountingCommissions() {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [showCommissionDetailsModal, setShowCommissionDetailsModal] = useState(false);
  const [selectedCommissionId, setSelectedCommissionId] = useState(null);
  const [selectedCommissionRef, setSelectedCommissionRef] = useState(null)

  useEffect(() => {
    console.log("ref==", selectedCommissionId)
  })
      const getIntermediaryCommissions = async () => {
      let resp = await (await api_srv).fetchIntermediaryCommisions();
        return resp.data;
      };



      const { isLoading: isCommissionLoading, isError: isCommissionError, isSuccess, data } = useQuery(
        "intermediaryCommissions",
        getIntermediaryCommissions
      );

      console.log("DATAA123=", data)

      let commissions = []
      if(!!data){
          commissions = data[0]?.items;
      }
      
  // Loading state is no longer needed with static data
  const isLoading = false;
  const isError = false;

  if (isLoading) {
    return <div>Loading commissions...</div>;
  }

  if (isError) {
    return <div>Error loading commissions</div>;
  }

  // Ensure commissions is an array; fallback to empty array if undefined
  const commissionData = Array.isArray(commissions) ? commissions : [];

  const tableFields = [
    { name: "Currency" },
    { name: "Total Earned" },
    { name: "Commission Applied" },
    { name: "Remarks"},
    { name: "Status" },
    { name: "Created" },
    { name: "Action" },
  ];

  const tableRowData = [
    { type: "text", field: "currency" },
    { type: "number", field: "amount" },
    { type: "number", field: "commisionApplied" },
    { type: "text", field: "settlmentTransaction.settledRemarks" },
    { type: "text", field: "settlmentTransaction.settlementStatus" },
    { type: "date", field: "createdAt" },
    {
      type: "action",
      field: "systemEntityCommisionRef",
      actions: [
        {
          method: (id) => {
            setSelectedCommissionId(id);
            setShowCommissionDetailsModal(true);
          },
          field: "id",
          title: "View",
        },
                {
          method: (id) => {
            setSelectedCommissionId(id);
            setShowModal(true);
          },
          field: "id",
          title: "Download",
        },
      ],
    },
  ];



  // Calculate summary metrics
  const totalEarned = commissionData.reduce((sum, comm) => sum + (comm.totalEarned || 0), 0);
  const totalToday = commissionData.reduce((sum, comm) => sum + (comm.todayEarned || 0), 0);
  const thisWeekEarned = commissionData.reduce((sum, comm) => sum + (comm.weeklyEarned || 0), 0);
  const thisMonthEarned = commissionData.reduce((sum, comm) => sum + (comm.monthlyEarned || 0), 0);

  const handleCloseModal = () => {
    setShowModal(false);
    setShowCommissionDetailsModal(false)
    setSelectedCommissionId(null);
  };

  return (
    <div className="#card #shadow p-4">
      <div className="mb-4">
        {/* <h4 className="mb-1">This Shows Your Commission Summaries</h4>
        <p className="text-muted mb-4">Earned (Commission You Have Earned)</p> */}
        
        {/* <Row className="mb-4">
          <Col md={3}>
            <Card className="shadow-sm mb-3" style={{ borderRadius: "10px", border: "none" }}>
              <Card.Body className="d-flex align-items-center">
                <TrendingUp size={40} className="text-primary me-3" />
                <div>
                  <Card.Title style={{ fontSize: "1.0rem", fontWeight: "600" }}>Total</Card.Title>
                  <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    KES {totalEarned.toLocaleString()}
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="shadow-sm mb-3" style={{ borderRadius: "10px", border: "none" }}>
              <Card.Body className="d-flex align-items-center">
                <TrendingUp size={40} className="text-info me-3" />
                <div>
                  <Card.Title style={{ fontSize: "1.0rem", fontWeight: "600" }}>Total Today</Card.Title>
                  <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    KES {totalToday.toLocaleString()}
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="shadow-sm mb-3" style={{ borderRadius: "10px", border: "none" }}>
              <Card.Body className="d-flex align-items-center">
                <TrendingUp size={40} className="text-success me-3" />
                <div>
                  <Card.Title style={{ fontSize: "1.0rem", fontWeight: "600" }}>This Week</Card.Title>
                  <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    KES {thisWeekEarned.toLocaleString()}
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="shadow-sm mb-3" style={{ borderRadius: "10px", border: "none" }}>
              <Card.Body className="d-flex align-items-center">
                <TrendingUp size={40} className="text-warning me-3" />
                <div>
                  <Card.Title style={{ fontSize: "1.0rem", fontWeight: "600" }}>This Month</Card.Title>
                  <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    KES {thisMonthEarned.toLocaleString()}
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row> */}

        {/* <p className="text-muted mb-3">Settlement (Commission You Have Been Paid By Name)</p>
        
        <TableComponent
          title="Settlement Details"
          table_fields={settlementTableFields}
          table_data={settlementData}
          row_data={settlementTableRowData}
          pageSize={10}
        /> */}

        <p className="text-muted mb-3 mt-4">Underwriters (Commission Earned Per Underwriter)</p>
      </div>

      <TableComponent
        title="Commission Details"
        table_fields={tableFields}
        table_data={commissionData}
        row_data={tableRowData}
        pageSize={10}
      />

      <DownloadReport show={showModal} onHide={handleCloseModal} commissionId={selectedCommissionId} />
      <ViewIntermeediaryCommissionDetails show={showCommissionDetailsModal} onHide={handleCloseModal} selectedCommissionId={selectedCommissionId} />
      
    </div>
  );
}

export default AccountingCommissions;